import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import PersonIcon from '@material-ui/icons/Person';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import { blue } from '@material-ui/core/colors';
import Grid from '@material-ui/core/Grid';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const emails = ['username@gmail.com', 'user02@gmail.com'];
const useStyles = makeStyles({
  avatar: {
    backgroundColor: '#121E2E',
    color: blue[600],
  },
});

 const SuccessNotification = (props) => {
  const classes = useStyles();
  const { onClose, selectedValue, open } = props;
  return (
    <Dialog onClose={props.handleClose} aria-labelledby="simple-dialog-title" open={props.open}>
        
        <Grid  
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justify="center"
        style={{ minHeight: '35vh',  color:'#121E2E' }}
        >
        <CheckCircleIcon style={{fontSize:80, marginBottom:10}}/>
        <DialogTitle id="simple-dialog-title">{props.msg}</DialogTitle>
        {/* <Button variant="contained" color="primary">
  Ok
</Button> */}
        </Grid>
      
    </Dialog>
  );
}
export default SuccessNotification;

